import * as React from "react";
import { Button } from "@mui/material";
import { ButtonsContainer } from "./ChangeGroupMemberPopup.styled";
import { ModalWindow } from "../../../shared/components/modalWindow/ModalWindow";
import {
  useGetGroupDropdownQuery,
  useSetGroupMembersMutation,
} from "../../../services/InsuranceService";
import SearchableSelect from "../../../components/formFields/SearchableSelect";

import { useEffect } from "react";
import { LoadingPanel } from "../../../shared/components/LoadingPanel";
import { useState } from "react";

export const ChangeGroupMemberPopup = ({ currentGroupId, memberId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [groupId, setGroupId] = useState(currentGroupId);

  const { data } = useGetGroupDropdownQuery("", { skip: !isOpen });

  const [setGroupMember, { isSuccess, error, isLoading }] =
    useSetGroupMembersMutation();

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (currentGroupId && !groupId) setGroupId(currentGroupId);
  }, [currentGroupId]);

  const onClose = () => {
    setIsOpen(false);
  };
  const onSave = () => {
    if (groupId && groupId.id !== currentGroupId.id) {
      setGroupMember({
        memberId,
        groupId,
      });
    } else {
      onClose();
    }
  };
  const onChange = (value) => {
    setGroupId(value);
  };
  return (
    <>
      <Button variant="outlined" onClick={() => setIsOpen(true)} sx={{ mb: 1 }}>
        Change Group
      </Button>
      <ModalWindow open={isOpen} onClose={onClose} header="Change Group">
        {isLoading && <LoadingPanel />}
        <SearchableSelect
          name="group"
          label={"Group"}
          fullWidth
          multiline
          options={data}
          field={{ value: groupId }}
          value={groupId}
          onChange={onChange}
        />
        <ButtonsContainer>
          <Button variant="outlined" onClick={onSave}>
            Save
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </ButtonsContainer>
      </ModalWindow>
    </>
  );
};
